// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3FgEp","bigColWidth":"Table_bigColWidth__2Foih","biggerColWidth":"Table_biggerColWidth__3cSGn","row":"Table_row__2CQkA","col":"Table_col__DjDvs"};